var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content__main content__main_without-right-aside"},[(_vm.loading)?_c('Loading'):(_vm.useDesktopLayout)?_c('another-person'):_c('person')],1)}
var staticRenderFns = []

export { render, staticRenderFns }